<h3-objectless-view-settings-slider
  label="Brightness"
  [default]="defaultBrightness"
  [setting]="settingName"
  [nasModel]="layerStore"
  [disabled]="disabled$ | async"
  [settingStore]="layerStore"
></h3-objectless-view-settings-slider>
